import React, { Component } from 'react'
import ContentLoader from 'react-content-loader'
import * as styles from './index.scss'

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  style?: React.CSSProperties
  loading?: boolean
}

interface State {
  isLoad: boolean
  onloaded: boolean
}

class ImgWrapper extends Component<Props, State> {
  static defaultProps = {
    loading: false,
  }
  constructor(props) {
    super(props)
    this.state = {
      isLoad: true,
      onloaded: false,
    }
  }

  static getDerivedStateFromProps() {
    return {
      isLoad: true,
    }
  }

  shouldComponentUpdate(props) {
    if (this.props.src === props.src && this.state.onloaded) {
      return false
    }
    return true
  }

  handleImgError = () => this.setState({ isLoad: false })

  handleImgLoad = () => this.setState({ onloaded: true })

  render() {
    const { isLoad, onloaded } = this.state
    const { width, height, style, loading, ...props } = this.props
    const MyLoader = (
      <ContentLoader
        height={height}
        width={290}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
        }}
      />
    )
    const blockImg = (
      <div
        style={{
          width: `${width}px` || '100%',
          height: `${height}px` || '100%',
          backgroundColor: '#CACACA',
          ...style,
        }}
      />
    )
    return (
      <div className={styles.image}>
        {loading && (!onloaded && MyLoader)}
        {isLoad ? (
          <img
            width={width || '100%'}
            height={height || '100%'}
            onLoad={this.handleImgLoad}
            onError={this.handleImgError}
            style={{
              ...style,
              opacity: onloaded ? 1 : 0,
            }}
            {...props}
          />
        ) : (
          blockImg
        )}
      </div>
    )
  }
}

export default ImgWrapper
